const IconCaretRight = ({className, onClick}) => {
  return (
    <svg onClick={onClick} className={`text-white w-6 h-6 fill-current ${className}`}  viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
      <path d="M1152 896q0 26-19 45l-448 448q-19 19-45 19t-45-19-19-45v-896q0-26 19-45t45-19 45 19l448 448q19 19 19 45z" />
    </svg>
  )
}

export default IconCaretRight;
